import { render, staticRenderFns } from "./resetEmail.vue?vue&type=template&id=d53eb334&"
import script from "./resetEmail.vue?vue&type=script&lang=js&"
export * from "./resetEmail.vue?vue&type=script&lang=js&"
import style0 from "./resetEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports